import * as React from "react";
import { useDispatch } from "react-redux";

import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";

import { getPreviewDataApiCall } from "../redux/apiCalls";
import { TEXT } from "../../../shared/constants/texts";

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.mjs`;

const PreviewPopup: React.FC = () => {
  const dispatch = useDispatch();
  const [pdfContent, setPdfContent] = React.useState(null);
  const [numPages, setNumPages] = React.useState(null);
  const apiCallParams = {
    dispatch: dispatch,
  };

  React.useEffect(() => {
    getPreviewData();
  }, []);

  const getPreviewData = async () => {
    const token = getParameterByName("token").replace(/['"]+/g, "");
    const filePath = getParameterByName("fullFilePath");
    const previewResponse = await getPreviewDataApiCall({ ...apiCallParams, filePath, requestData: token });
    const { response, error } = previewResponse;
    if (response) {
      let transformedResponse = response;
      if ("$value" in transformedResponse) {
        transformedResponse = transformedResponse["$value"];
        const content = `data:application/pdf;base64,${transformedResponse}`;
        setPdfContent(content);
      }
      if (error) {
        setPdfContent(null);
      }
    }
  };

  const getParameterByName = (name, url = window.location.hash) => {
    name = name.replace(/[\[\]]/g, "\\$&");
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  return (
    <React.Fragment>
      {pdfContent ? (
        <div className="preview-popup">
          <Document file={pdfContent} onLoadSuccess={onDocumentLoadSuccess}>
            {Array.from(new Array(numPages), (_el, index) => (
              <Page key={`page_${index + 1}`} pageNumber={index + 1} renderTextLayer={false} />
            ))}
          </Document>
        </div>
      ) : (
        <p>{TEXT.LOADING_PDF}</p>
      )}
    </React.Fragment>
  );
};

export default PreviewPopup;
